import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import api from "../core/api"
import dayjs from "../core/day"
import { downloadFile } from "../core/utils"

import Back from "../components/Back"

class Extratos extends React.Component {
    constructor() {
        super()
        this.gerarPDF = this.gerarPDF.bind(this)
    }
    state = {
        carregando: false,
        mes: dayjs().format("MM"),
        ano: dayjs().format("YYYY"),
        title: "",
        carregandoBtn: false,
        repasses: []
    }

    componentDidMount() {
        this.getExtratos()
    }

    getExtratos() {
        let { ano, mes } = this.state
        let dateTitle = dayjs(ano + "-" + mes + "-01").format("MMMM [de] YYYY")
        this.setState({ title: `Extrato de repasses do mes de ${dateTitle}`, carregando: true })
        api.get("/contratos/extratos", {
            params: { mes: this.state.mes, ano: this.state.ano }
        })
            .then(response => {
                this.setState({ carregando: false, repasses: response.data.repasses })
            })
            .catch(err => {})
    }

    gerarPDF() {
        let mes = this.state.mes
        let ano = this.state.ano
        this.setState({ carregandoBtn: true })
        downloadFile(
            `/contratos/extratosPDF?mes=${mes}&ano=${ano}`,
            `extratos-${mes}-${ano}.pdf`
        ).then(() => {
            this.setState({ carregandoBtn: false })
        })
    }

    listAno() {
        let ans = []
        for (let i = 2018; i <= dayjs().format("YYYY"); i++) {
            ans.push(i)
        }
        return ans
    }

    render() {
        let classBtnPDf = this.state.carregandoBtn
            ? "button is-warning is-loading"
            : "button is-warning"
        return (
            <section className="section">
                <div className="container content">
                    <div className="card">
                        <header className="card-header content-header">
                            <Back />
                            <h3 className="title is-5 nomargin">Extratos</h3>
                        </header>
                        <div className="card-content">
                            <div className="card-info">
                                <div className="form-filtro">
                                    <p
                                        style={{
                                            marginRight: 10,
                                            marginBottom: 0,
                                            fontWeight: "bold"
                                        }}
                                    >
                                        Filtrar extratos por mês/ano
                                    </p>
                                    <div className="field">
                                        <div className="control">
                                            <div className="select">
                                                <select
                                                    value={this.state.mes}
                                                    onChange={e =>
                                                        this.setState({
                                                            mes: e.target.value
                                                        })
                                                    }
                                                >
                                                    <option value="01">Janeiro</option>
                                                    <option value="02">Fevereiro</option>
                                                    <option value="03">Março</option>
                                                    <option value="04">Abril</option>
                                                    <option value="05">Maio</option>
                                                    <option value="06">Junho</option>
                                                    <option value="07">Julho</option>
                                                    <option value="08">Agosto</option>
                                                    <option value="09">Setembro</option>
                                                    <option value="10">Outubro</option>
                                                    <option value="11">Novembro</option>
                                                    <option value="12">Dezembro</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <div className="control">
                                            <div className="select">
                                                <select
                                                    value={this.state.ano}
                                                    onChange={e =>
                                                        this.setState({
                                                            ano: e.target.value
                                                        })
                                                    }
                                                >
                                                    {this.listAno().map(a => {
                                                        return (
                                                            <option
                                                                key={`ano_${a.toString()}`}
                                                                value={a}
                                                            >
                                                                {a}
                                                            </option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="field">
                                        <div className="control">
                                            <button
                                                onClick={() => this.getExtratos()}
                                                className="button is-primary"
                                            >
                                                Filtrar
                                            </button>
                                            &nbsp;
                                            <button
                                                onClick={() => this.gerarPDF()}
                                                className={classBtnPDf}
                                            >
                                                Gerar PDF
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div className="title-section">{this.state.title}</div>
                            {this.state.carregando ? (
                                <div className="card-content">Aguarde...</div>
                            ) : (
                                <table className="table is-bordered" style={{ marginTop: 5 }}>
                                    <thead>
                                        <tr>
                                            <th>Imóvel</th>
                                            <th>Cod. Cotrato</th>
                                            <th>Valor</th>
                                            <th>Pagamento</th>
                                            <th style={{ width: 80, textAlign: "center" }}>
                                                Extrato
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.repasses.map(repasse => {
                                            return (
                                                <tr key={repasse.numero.toString()}>
                                                    <td>{repasse.imovel.endereco}</td>
                                                    <td>{repasse.contrato.codigo}</td>
                                                    <td>{repasse.valor}</td>
                                                    <td>{repasse.date}</td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <a
                                                            rel="noopener noreferrer"
                                                            href={repasse.link}
                                                            target="_blank"
                                                            className="button is-primary is-small"
                                                        >
                                                            Ver Extrato
                                                        </a>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = state => ({
    contrato: state.contrato
})

export default withRouter(connect(mapStateToProps)(Extratos))
